export default __webpack_public_path__ + "static/abhaziya-celo-pskhu-cerkov-useknoveniya-glavy-ioanna-predtechi_8-cca7c1edb27767a02f7cfebdfb0cd28a.jpg";